import React, { useEffect, useState } from "react";
import TableListing from "../common/tableListing";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import { UserObj } from "../../services/localStarage";
import _ from "lodash";
import { getSecPermission } from "../../constant";

const initialColumns = [
  { id: "requestId", label: "Request ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT", isRedirect: true, redirectUrl:"/admin/po-modification-detail", redirectKeyName: "_id" },
  { id: "referenceNumber", label: "Refrence Id", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "requestType", label: "Request Type", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "requester", label: "Created By", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorName", label: "Vendor Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "vendorCode", label: "Vendor Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "prNumber", label: "PR Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "poNumber", label: "PO Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "assignee", label: "Assignee", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "requestDate", label: "Request Date", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "updatedAt", label: "Updated on", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "status", label: "Status", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "col10", label: "Actions", isSort: true, sortLabel: "" },
];

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function ModificationList() {
  
  const [secPORequestPermission, setSecPORequestPermission] = useState({
    "PO_REQUEST_LISTING": permissionInit,
    "CREATE_QUANTITY_MOD_REQ": permissionInit,
    "CREATE_PRICE_MOD_REQ": permissionInit,
    "PO_REQUEST_DETAILS": permissionInit,
    "APPROVE_PO_REQUEST": permissionInit,
    "REJECT_PO_REQUEST": permissionInit,
    "ASSIGN_PO_REQUEST": permissionInit,
    "SUBMIT_PO_REQUEST": permissionInit,
  });
  
  useEffect(() => {
    let secPORequestPermissionInit = _.cloneDeep(secPORequestPermission);
    let obj = {};
    for (let key in secPORequestPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecPORequestPermission(obj);
    // getSummary("?uniqueName=LORRY_RECEIPT");

  }, []);

  const dummyFun = (param) => {  };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_mains">
                <h5>PO Modification Request</h5>
              </div>
            </div>
  
            <TableListing
                column={initialColumns}
                listingArrName="requests"
                filterKeyName={UserObj?.role?.name == "VENDOR" ? "PO_REQUEST_VENDOR" : "PO_REQUEST_INTERNAL"}
                componentName="PO_MODIFICATION_LIST"
                promiseRequest={purchaseOrderServices?.getPORequestListing}
                onFilterChange={dummyFun}
                promiseUrlType="LIST"
                additionalData={{
                  isMaster: false,
                  type: "PO Modification Request",
                  isTrackOrder: false,
                  isFilter: true,
                  isSearch: true,
                  isPagePerSize: true,
                  isPagination: true,
                  isDragable: true,
                  is_CREATE_QUANTITY_MOD_REQ: secPORequestPermission?.CREATE_QUANTITY_MOD_REQ?.read,
                  is_CREATE_PRICE_MOD_REQ: secPORequestPermission?.CREATE_PRICE_MOD_REQ?.read,
                }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ModificationList